import styled from 'styled-components';

export const StyledMenu = styled.nav`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 32px;
  padding-left: 42px;
  padding-top: 100px;
  background: #e0d1b6;
  height: 100vh;
  text-align: right;
  position: absolute;
  font-family: 'utopia-std';
  top: 0;
  right: 0;
  transition: transform 0.2s ease-in-out;
  transform: ${({ open }) => (open ? 'translateX(0)' : 'translateX(100%)')};

  @media (max-width: 639px) {
    width: 100%;
  }

  a {
    font-size: 2rem;
    text-transform: uppercase;
    padding: 2rem 0;
    font-weight: bold;
    letter-spacing: 0.5rem;
    color: #001826;
    text-decoration: none;
    transition: color 0.3s linear;

    @media (max-width: 680) {
      font-size: 1.5rem;
      text-align: center;
    }

    &:hover {
      color: #152a38;
    }
  }
`;
